import { getAuthHeader } from "./authHelper";
import { unknownError, notSignedIn } from "../constants/errorMessages"; 

const { REACT_APP_API_BASEURL } = process.env;

/**
 * Calls the contributions api with the provided data
 * @param {string} url e.g: item/1234
 * @param {{skip: number, top: number, headers:{}, options: {method:string, body: string, params: {}}}} options object for further configuring the request
 * @returns the json response
 */
export const callApi = async (url, options = null) => {
  let fullUrl = `${REACT_APP_API_BASEURL}${url}`;
  // append query params if present
  if (options && options.params) {
    const params = new URLSearchParams(options.params);
    fullUrl += `?${params}`;
  }
  // call the api
  try {
    const response = await fetch(fullUrl, {
      ...options?.options,
      headers: {
         Authorization: getAuthHeader(),
        ...options?.headers,
      },
    });

    if (response.ok) {
      // If the response is a 200 call to .json(), if it isn't (e.g. a 204) just return a response object
       return response.status === 200 ? await response.json() : { isValid: true, errors: []};
    } else {
      // If the status code is unauthorized, show the "sign in" error message, else get the errors from the response
      if (response.status === 401) {
        return {
          isValid: false,
          errors: [{ errorMessage: notSignedIn }],
        };
      } else {
        let errors = await response.text();
        errors = JSON.parse(errors);

        let errorMessageArray = [];
        for (let i = 0; i < errors.errors.length; i++) {
          const error = { errorMessage: errors.errors[i].errorMessage };
          errorMessageArray.push(error);
        }
        return {
          isValid: false,
          errors: errorMessageArray,
        };
      }
    }
  } catch (err) {
    return { isValid: false, errors: [{ errorMessage: unknownError }] };
  }
};

/**
 *
 * @param {object} response the response object from the API
 * @param {*} thunkAPI the thunkAPI
 * @returns returns a rejected value if the response is invalid, otherwise returns the response
 */
export const verifyResponse = (response, thunkAPI) => {
  if (response.isValid !== undefined && !response.isValid) {
    return thunkAPI.rejectWithValue(response.errors);
  }
  return response;
};
